import React from 'react';

import * as Yup from 'yup';
import { Link } from 'react-router-dom';
import { Checkbox, Button, FormControlLabel } from '@material-ui/core';
import { Grid, Paper, TextField, Typography } from '@material-ui/core';

import { ButtonContainer, Form, ModalRoot } from 'components';
import { backLink } from 'utils';

import styles from './ChannelForm.module.scss';

const validate = Yup.object().shape({
  name: Yup.string().required('Required'),
  token: Yup.string().required('Required'),
  mobile: Yup.boolean(),
});

const ChannelForm = props => {
  const { channelData, onSubmit } = props;

  if (!channelData) {
    return null;
  }

  const { id, name, token, mobile } = channelData;

  return (
    <div className={styles.channelForm}>
      <Typography variant="h6" gutterBottom>
        {id ? 'Edit channel' : 'Create new channel'}
      </Typography>

      <Form
        validationSchema={validate}
        initialValues={{ name, token, mobile }}
        onSubmit={onSubmit}
      >
        {({ fieldProps, checkboxProps, isSubmitting }) => (
          <Grid item xs={12}>
            <Paper className={styles.paper}>
              <Grid container spacing={3}>
                <Grid item xs={6}>
                  <TextField {...fieldProps('name', 'Channel Name')} />
                </Grid>

                <Grid item xs={6}>
                  <TextField {...fieldProps('token', 'Channel Token')} />
                </Grid>
              </Grid>

              <Grid item xs={6}>
                <FormControlLabel
                  control={<Checkbox {...checkboxProps('mobile')} color="primary" />}
                  label="Default channel for mobile APPs"
                />
              </Grid>
            </Paper>

            <ButtonContainer>
              <Button component={Link} to={backLink(props)}>
                cancel
              </Button>

              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={isSubmitting}
              >
                {id ? 'save' : 'create'}
              </Button>
            </ButtonContainer>
          </Grid>
        )}
      </Form>

      <ModalRoot />
    </div>
  );
};

export default ChannelForm;
